<template>
  <div class="container">
    <transition name="slide-fade">
      <div class="top">
        <el-carousel
          indicator-position="none"
          height="100%"
          :interval="3000"
          arrow="never"
          trigger="never"
        >
          <el-carousel-item v-for="(item,index) in this.banner.image" :key="index">
            <div
              class="banner"
              :style=" 'background-image: url(' + item + ');background-size: cover;'"
            >
              <p class="bannerp1">{{bannertitle1}}</p>
              <p class="bannerp2">{{bannertitle2}}</p>
              <p class="bannerp2">{{bannertitle3}}</p>
              <img
                class="bannerimg"
                src="../assets/dashu/bannerbottom.png"
                alt
                @click="routerdetails(930)"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </transition>
    <!-- 服务 -->
    <div class="about service">
      <p class="text-linear">Advantages and services</p>
      <!-- <p class="text-title">{{aas}}</p> -->
      <p class="under-line"></p>
      <div class="service-con">
        <div class="service-item">
          <img class="service-icon" src="../assets/dashu/sevice_1.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.operate_image" alt /> -->
          <div class="servic-title">{{service1}}</div>
          <div class="service-detail">
            <div>{{service1desc}}</div>
            <!-- <div>{{this.strs1[0]}}</div> -->
            <!-- <div>{{this.strs1[1]}}</div> -->
          </div>
        </div>

        <div class="service-item">
          <img class="service-icon" src="../assets/dashu/service_2.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.management_image" alt /> -->
          <div class="servic-title">{{service2}}</div>
          <div class="service-detail">
            <div>{{service2desc}}</div>
            <!-- <div>{{this.strs2[0]}}</div> -->
            <!-- <div>{{this.strs2[1]}}</div> -->
          </div>
        </div>

        <div class="service-item" style="margin-bottom:60px">
          <img class="service-icon" src="../assets/dashu/service_3.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.source_image" alt /> -->
          <div class="servic-title">{{service3}}</div>
          <div class="service-detail">
            <div>{{service3desc}}</div>
            <!-- <div>{{this.strs3[0]}}</div> -->
            <!-- <div>{{this.strs3[1]}}</div> -->
          </div>
        </div>

        <div class="service-item" style="margin-bottom:60px">
          <img class="service-icon" src="../assets/dashu/service_4.png" alt />
          <!-- <img class="service-icon" :src="this.servicearray.logistics_image" alt /> -->
          <div class="servic-title">{{service4}}</div>
          <div class="service-detail">
            <div>{{service4desc}}</div>
            <!-- <div>{{this.strs4[0]}}</div> -->
            <!-- <div>{{this.strs4[1]}}</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="about about-long">
      <!-- <p class="text-linear">ABOUT US</p>
      <p class="text-title">{{aboutus}}</p>-->
      <div class="about-div">
        <div class="about-div1"></div>
        <div class="about-div2">
          <div class="about-title">About Us</div>
          <div class="aboutExplain">{{aboutusdesc}}</div>
          <div class="more" @click="toAbout">
            {{aboutusmore}}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻中心 -->
    <div class="news">
      <p class="text-linear">Information Center</p>
      <p class="under-line"></p>
      <!-- <p class="text-title">{{news}}</p> -->
      <span class="news-span">
        <span @click="toNewsCenter" style="cursor:pointer">
          {{newsmore}}
          <i class="el-icon-arrow-right"></i>
          <i class="el-icon-arrow-right"></i>
        </span>
      </span>
      <div class="three">
        <div
          class="three1"
          :style=" 'background-image: url(' + this.newarray[0].image + ');'"
          @mouseenter="logoFlag1 = 1"
          @mouseleave="logoFlag1 = 0"
        >
          <div class="newtitle" v-if="logoFlag1">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].title:this.newarray[0].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].introduce:this.newarray[0].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails0() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[0].title:this.newarray[0].title_en}}</span>
          </div>
        </div>
        <div
          class="three2"
          :style=" 'background-image: url(' + this.newarray[1].image + ');'"
          @mouseenter="logoFlag2 = 1"
          @mouseleave="logoFlag2 = 0"
        >
          <div class="newtitle" v-if="logoFlag2">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].title:this.newarray[1].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].introduce:this.newarray[1].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails1() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[1].title:this.newarray[1].title_en}}</span>
          </div>
        </div>
        <div
          class="three3"
          :style=" 'background-image: url(' + this.newarray[2].image + ');'"
          @mouseenter="logoFlag3 = 1"
          @mouseleave="logoFlag3 = 0"
        >
          <div class="newtitle" v-if="logoFlag3">
            <span
              class="newtitle-span1"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].title:this.newarray[2].title_en}}</span>
            <span
              class="newtitle-span2"
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].introduce:this.newarray[2].introduce_en}}</span>
            <span class="newtitle-span3" @click="routerdetails2() ">
              {{aboutusmore}}
              <i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="newtitle2" v-else>
            <span
              style=" -webkit-box-orient: vertical;"
            >{{ischinese == "cn" ?this.newarray[2].title:this.newarray[2].title_en}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="innovation">
      <p class="text-linear">Innovation</p>
      <p class="under-line"></p>
      <h3 class="long-innovation-test">Cultural Genes Imprinted in the Blood of Dashu</h3>
      <div class="inn1">
        <div class="inn1-1">
          <img class="innimgl" src="../assets/dashu/c_1.png" alt />
          <img class="innimgr" src="../assets/dashu/c_2.png" alt />
          <div class="inntitle1">{{inntitle1}}</div>
          <div class="inndesc1">{{inndesc1}}</div>
          <div class="inntitle2">{{inntitle2}}</div>
          <div class="inndesc2">{{inndesc2}}</div>
        </div>
        <div class="inn1-2">
          <p class="inn1-2pp">{{inn12pp}}</p>
          <p class="under-line"></p>
          <div class="inn1-2-1">
            <div class="inn1-2-1-1">
              <img class src="../assets/dashu/inn2.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp1}}</p>
                <p class="innp2">{{innp2}}</p>
              </div>
            </div>
            <div class="inn1-2-1-1 inncenter">
              <img class src="../assets/dashu/inn4.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp3}}</p>
                <p class="innp2">{{innp4}}</p>
              </div>
            </div>
            <div class="inn1-2-1-1">
              <img class src="../assets/dashu/inn5.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp5}}</p>
                <p class="innp2">{{innp6}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inn2">
      <p class="inn1-2p">{{inn2_1}}</p>
      <p class="under-line"></p>
      <div class="inn2-2-1">
        <div class="inn2-2-1-1">
          <div class="img-con">
            <img class="inn2-img" src="../assets/dashu/inn6.png" alt />
          </div>
          <p class="innp1_2">{{inn2_2}}</p>
          <ul>
            <li>{{inn2_3}}</li>
            <li>{{inn2_4}}</li>
            <li>{{inn2_5}}</li>
          </ul>
        </div>
        <div class="inn2-2-1-1">
          <div class="img-con">
            <img class="inn2-img" src="../assets/dashu/inn7.png" alt />
          </div>
          <p class="innp1_2">{{inn2_6}}</p>
          <ul>
            <li>{{inn2_7}}</li>
            <li>{{inn2_8}}</li>
            <li>{{inn2_9}}</li>
            <li>{{inn2_10}}</li>
          </ul>
        </div>
        <div class="inn2-2-1-1">
          <div class="img-con">
            <img class="inn2-img" src="../assets/dashu/inn8.png" alt />
          </div>
          <p class="innp1_2">{{inn2_11}}</p>
          <ul>
            <li>{{inn2_12}}</li>
            <li>{{inn2_13}}</li>
          </ul>
        </div>
        <div class="inn2-2-1-1">
          <div class="img-con">
            <img class="inn2-img" src="../assets/dashu/inn9.png" alt />
          </div>
          <p class="innp1_2">{{inn2_14}}</p>
          <ul>
            <li>{{inn2_15}}</li>
            <li>{{inn2_16}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="inn3">
      <p class="inn1-2ppp">{{inn3_1}}</p>
      <p class="under-line"></p>
      <div class="inn2-2-1">
        <div class="inn3-2-1-1">
          <p class="innp3">{{inn3_2}}</p>
          <ul>
            <li>{{inn3_3}}</li>
            <li>{{inn3_4}}</li>
            <li>{{inn3_5}}</li>
          </ul>
        </div>
        <div class="inn3-2-1-1">
          <p class="innp3">{{inn3_6}}</p>
          <ul>
            <li>{{inn3_7}}</li>
            <li>{{inn3_8}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="about bread-about about2">
      <p class="text-linear">Cooperation brand</p>
      <!-- <p class="text-title">{{cb}}</p> -->
      <p class="under-line"></p>

      <div class="cooperation">
        <!-- swiper -->
        <swiper class="swiper-con" :options="swiperOption">
          <swiper-slide>
            <div class="slide-title">{{cb1}}</div>
            <div class="bread-con">
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/3.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/15.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/18.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/13.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/26.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/24.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/19.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/31.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/18.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/23.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/27.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/12.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/4.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-title">{{cb2}}</div>
            <div class="muying-con">
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/2.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/1.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/9.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/17.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/10.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/25.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide-title">{{cb3}}</div>
            <div class="food-con">
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/6.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/7.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/30.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/14.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/22.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/16.png" alt="品牌" />
              </div>
              <div class="bread-item">
                <img class="img-size" src="../assets/dashu/a/29.png" alt="品牌" />
              </div>
            </div>
          </swiper-slide>
          

          <div class="swiper-button-prev swiper-black" slot="button-prev">
            <img src="../assets/dashu/swiper_next.png" alt />
          </div>
          <div class="swiper-button-next swiper-white" slot="button-next">
            <img src="../assets/dashu/swiper_next.png" alt />
          </div>
          <!-- 白色 -->
          <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
      </div>
    </div>

    <div class="about-us">
      <div class="about1">
        <div class="about1-2">
          <!-- <p class="aboutp1 one">{{ischinese == "cn" ?this.about.title:this.about.title_en}}</p> -->
          <p class="aboutp1 one">About Us</p>
          <p class="about-text-long">China's Leading Cross-border Brand Management Company</p>
          <p class="aboutp1 s-margin">{{aboutp1}}</p>
          <div class="servicesp1" style="width: 100%;">{{this.strs[0]}}</div>
          <div class="servicesp2" style="width: 100%;">{{this.strs[1]}}</div>
          <p class="aboutp1 s-margin">{{aboutp2}}</p>
          <div
            class="servicesp2"
            style="width: 100%; padding-bottom: 20px"
          >{{ischinese == "cn" ?this.about.mission:this.about.mission_en}}</div>
        </div>
      </div>
    </div>
    <!-- 加入我们 -->
    <div class="join-con">
      <div class="join-title">{{bannertext1}}</div>
      <div class="join-title2">{{bannertext2}}</div>
      <div class="join-content-con">
        <div class="why-join">Why to Join Us</div>
        <div class="why">{{this.joinstrs[0]}}</div>
        <div class="why">{{this.joinstrs[1]}}</div>
      </div>
    </div>
    <!-- 招聘 -->
    <div class="recruit-con">
      <div class="recruit-title">Recruitment Content</div>
      <p class="under-line"></p>
      <div class="recruit-flex">
        <div
          class="recruit-item"
          :style="'width: ' + joincenter + '0%;'"
          v-for="(item,index) in this.joinarray"
          :key="index"
        >
            <div class="recruit-icon">
              <img :src="item.image" alt="">
            </div>
            <div class="recruit-name">{{item.title_en}}</div>
            <div class="recruit-detail">
               <div v-for="(items,index) in item.menu_en" :key="index">{{items}}</div>
            </div>
        </div>
      </div>
    </div>

      <Btfooter></Btfooter>
  </div>
</template>

<script>
// @ is an alias to /src
import Btfooter from "../components/Footer";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Home",
  components: {Btfooter, swiper, swiperSlide },
  data() {
    return {
      ischinese: "cn",
      strs1: [],
      strs2: [],
      strs3: [],
      strs4: [],
      servicearray: {
        operate_image: ""
      },
      newarray: [
        {
          title: ""
        },
        {
          title: ""
        },
        {
          title: ""
        }
      ],
      logoFlag1: 0,
      logoFlag2: 0,
      logoFlag3: 0,
      banner: [],
      bannertitle1: "大树联合集团",
      bannertitle2: "大树联合集团开创于2018年，主要从事电子商",
      bannertitle3: "务、设计、程序等互联网业务",
      aboutus: "关于我们",
      aboutusdesc:
        "专注以提供品牌电子商务为核心的一站式商业解决方案，涉及店铺运营、数字营销、IT解决方案、仓储配送、客户服务等五大内容",
      aboutusmore: "了解更多",
      news: "新闻中心",
      newsmore: "查看更多",
      aas: "优势及服务",
      service1: "品牌代运管理",
      service1desc:
        "严格挑选境外品牌，良好的电商业务水平帮助品牌本土化定位及落地策略，确保长期深度战略合作化",
      service2: "多模式渠道管理",
      service2desc:
        "整合各类可触达的渠道，主流线上平台以及线下渠道覆盖，建立高效、精准可衡量的渠道跨屏营销体系",
      service3: "供应链管理",
      service3desc:
        "一站式清关服务，国际专线、跨境电商、智能保税仓储服务、国内配送，快速高效供应，无忧体验",
      service4: "数据管理",
      service4desc:
        "多年在电商行业精耕细作，掌握庞大电商行业数据，千万级粉丝经营、大数据管理经验",
      cb: "合作品牌",
      cb1: "美妆",
      cb2: "母婴",
      cb3: "食品",

      bannerp1: "创新",
      bannerp2: "烙印在大树血液里的文化基因",
      inntitle1: "大树的创新",
      inndesc1:
        "聚集国内外优秀人才，聚焦新技术及产品研究，以开放互联的理念，驱动企业创新发展。服务全球品牌用户，实现多语言，全球化，全渠道，理想的电商自运营；打造数据标准化，服务标准化的云计算平台，为云生态平台提供坚实的基础。",
      inntitle2: "创新布局",
      inndesc2:
        "战略布局基础云计算，电商云生态，大树大脑，大数据平台四大科技创新方向，为实现大树电商创新愿景不懈努力。",
      inn12pp: "创新优势",
      innp1: "先进的实施理念",
      innp2:
        "以产品思维取代项目思维，将产品化的理念彻底贯彻到创新的每一个环节，每一个员工。",
      innp3: "牢靠的根基",
      innp4:
        "先进的云计算技术平台，支撑起以大树多年品牌电商运营经验培育的电商云生态平台。",
      innp5: "标准化能力",
      innp6:
        "通过标准化的数据，打造标准产品，使大树具备提供标准化科技服务的能力。",
      inn2_1: "创新服务",
      inn2_2: "云计算平台",
      inn2_3: "SaaS化的电商计算平台",
      inn2_4: "提供标准化的服务接口与数据接口",
      inn2_5: "电商基础服务化产品",
      inn2_6: "先进的实施理念",
      inn2_7: "SaaS化的电子商务应用平台",
      inn2_8: "面向不同体量级别的品牌客户",
      inn2_9: "依照需求制定规划，精简流程",
      inn2_10: "优化预算支出与业务能力",
      inn2_11: "大树大脑",
      inn2_12:
        "基于大数据和深度学习，识别图片、视频中的视觉内容，应用于商品识别、商品推荐、趋势分析等场景",
      inn2_13:
        "构建知识图谱，描述产品与产品、产品与客户关系链路，挖掘潜在商业机会",
      inn2_14: "大数据平台",
      inn2_15:
        "以核心技术能力为依托，提供数据产品和分析服务与国内外知名学府深度合作智能工具",
      inn2_16: "提升商业效率，开拓业务场景，优化用户体验",
      inn3_1: "前沿研究",
      inn3_2: "图像数据深度研究",
      inn3_3: "通过技术手段采集数据",
      inn3_4: "由图像识别和深度学习方法获得有价值结论",
      inn3_5: "为品牌产品运营提供科学依据",
      inn3_6: "校企合作",
      inn3_7: "共同建立科学实验室",
      inn3_8: "将研究成果与企业日常运作结合",
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        setWrapperSize: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          navigationHide: function() {
            alert("按钮隐藏了");
          }
        },
        disabledClass: "my-button-disabled",
        hiddenClass: "my-button-hidden"
      },
      about: {
        mission: "",
        overview: "",
        vision: ""
      },
      strs: [],
      aboutp1: "业务概览",
      aboutp2: "大树的使命",
      aboutp3: "大树愿景",
      servicep: "为什么加入我们",
      inn12p: "招聘内容",
      bannertext1: "加入我们",
      bannertext2: "许给未来一个可能",
      joinarray: [],
      joincenter: 5,
      joinstrs: []
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    routerdetails(topnum) {
      document.documentElement.scrollTop = topnum;
      document.body.scrollTop = topnum;
    },

    //设置英文字段
    setEnText() {
      if (this.ischinese == "en") {
        this.bannertitle1 = "Dashu United Group";
        this.bannertitle2 =
          "Founded in 2018, Dashu united group is mainly engaged in ";
        this.bannertitle3 =
          "e-commerce, design, program and other Internet businesses";
        this.aboutus = "ABOUT US";
        this.aboutusdesc =
          "Focus on providing brand e-commerce as the core of one-stop business solutions, involving store operation, digital marketing, it solutions, warehousing and distribution, customer service, etc";
        this.aboutusmore = "Learn more";
        this.news = "News Center";
        this.newsmore = "View more";
        this.aas = "Advantages and services";
        this.service1 = "BrandTransportationManagement";
        this.service1desc =
          "We strictly select overseas brands. A good e-commerce business level is conducive to brand localization positioning and landing strategy, ensuring the depth of long-term strategic cooperation.";
        this.service2 = "Multi-modeChannelManagement";
        this.service2desc =
          "We will integrate all kinds of accessible channels, and mainstream online platforms and offline channel coverage to establish an efficient, accurate and measurable channel cross-screen marketing system.";
        this.service3 = "SupplyChainManagement";
        this.service3desc =
          "One-stop customs clearance service, international dedicated line, cross-border e-commerce, intelligent bonded warehousing service, domestic distribution, fast and efficient supply, and worry-free experience";
        this.service4 = "DataManagement";
        this.service4desc =
          "We have worked intensively in the e-commerce industry for many years and have mastered huge e-commerce industry data. We have tens of millions of fans and big data management experience.";
        this.cb = "Cooperation brand";
        this.cb1 = "Beauty makeup";
        this.cb2 = "Mother and infant";
        this.cb3 = "Food";
      }
      //
      if (this.ischinese == "en") {
        this.bannerp1 = "Innovation";
        this.bannerp2 = "Cultural Genes Imprinted in the Blood of Dashu";
        this.inntitle1 = "The Innovation of Dashu";
        this.inndesc1 =
          "We will gather outstanding talents at home and abroad, focus on new technologies and product research, and drive the innovation and development of enterprises with the concept of open interconnection. We serve global brand users and realize multilingual, global, full-channel and ideal e-commerce self-operation. We build a cloud computing platform for data standardization and service standardization to lay a solid foundation for the cloud ecological platform.";
        this.inntitle2 = "Innovative Layout";
        this.inndesc2 =
          "The strategic layout is based on four major scientific and technological innovation directions: basic cloud computing, e-commerce cloud ecology, Dashu brain and big data platform, making unremitting efforts to realize the vision of Dashu e-commerce innovation.";
        this.inn12pp = "Innovation Advantage";
        this.innp1 = "Advanced Implementation Concept";
        this.innp2 =
          "Dashu replaces project thinking with product thinking, and thoroughly implement the product concept to every link of innovation and every employee.";
        this.innp3 = "Solid Foundation";
        this.innp4 =
          "The advanced cloud computing technology platform supports the e-commerce cloud ecological platform, which is cultivated by Dashu for many years of brand e-commerce operation experience.";
        this.innp5 = "Standardization Capability";
        this.innp6 =
          "We create standardized products through standardized data so that Dashu can provide standardized scientific and technological services.";
        this.inn2_1 = "Innovative Service";
        this.inn2_2 = "Cloud Computing Platform";
        this.inn2_3 = "E-commerce Computing Platform Based on SaaS";
        this.inn2_4 =
          "Provide Standardized Service Interface and Data Interface";
        this.inn2_5 = "E-commerce Basic Service Products";
        this.inn2_6 = "Advanced Implementation Concept";
        this.inn2_7 = "E-commerce Application Platform Based on SaaS";
        this.inn2_8 = "Face Brand Customers of Different Size Levels";
        this.inn2_9 = "Plan and Streamline Processes According to Needs";
        this.inn2_10 = "Optimize Budget Expenditure and Business Capability";
        this.inn2_11 = "Dashu Brain";
        this.inn2_12 =
          "Based on big data and in-depth learning, visual content in pictures and videos is identified and applied to scenes such as commodity identification, commodity recommendation and trend analysis.";
        this.inn2_13 =
          "Build knowledge maps, describe product-to-product, product-to-customer relationship links, and tap potential business opportunities.";
        this.inn2_14 = "Big Data Platform";
        this.inn2_15 =
          "Relying on its core technical capabilities, it provides data products, analysis services and intelligent tools for in-depth cooperation with well-known universities at home and abroad.";
        this.inn2_16 =
          "Improve business efficiency, develop business scenarios, and optimize the user experience.";
        this.inn3_1 = "Frontier Research";
        this.inn3_2 = "Research on Depth of Image Data";
        this.inn3_3 = "Collect data by technical means";
        this.inn3_4 =
          "Valuable conclusions are obtained through image recognition and depth learning methods.";
        this.inn3_5 = "Provide Scientific Basis for Brand Product Operation";
        this.inn3_6 = "School-enterprise Cooperation";
        this.inn3_7 = "Joint Establishment of Scientific Laboratories";
        this.inn3_8 =
          "Combine the research results with the daily operation of the enterprise.";
      }
      if (this.ischinese == "en") {
        // this.bannertext1 = "China's Leading";
        // this.bannertext2 = "Cross-border Brand Management Company";
        this.aboutp1 = "Business Overview";
        this.aboutp2 = "The Mission of Dashu";
        this.aboutp3 = "The Vision of Dashu";
      }
      if (this.ischinese == "en") {
        this.servicep = "Why to Join Us";
        this.inn12p = "Recruitment Content";
        this.bannertext1 = "Join Us";
        this.bannertext2 = "Promise a Possibility to the Future";
      }
    },
    //获取轮播图
    getBanner() {
      this.$http
        .post("/api/dashu/index/bannerList", {})
        .then(res => {
          var code = res.data.code;
          if (code === 0) {
            this.banner = res.data.data.banner;
            // console.log(this.banner)
            this.newarray = res.data.data.new;
            //  console.log(this.newarray)
          }
        })
        .catch(function() {
          //  console.log(error);
        });
    },
    //获取服务
    getService() {
      this.$http.post("/api/dashu/service/serviceList", {}).then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.banner = res.data.data.banner.image;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            var str1 = res.data.data.lists.operate;
            var strs1 = str1.split("\n");
            this.strs1 = strs1;

            var str2 = res.data.data.lists.management;
            var strs2 = str2.split("\n");
            this.strs2 = strs2;

            var str3 = res.data.data.lists.source;
            var strs3 = str3.split("\n");
            this.strs3 = strs3;

            var str4 = res.data.data.lists.logistics;
            var strs4 = str4.split("\n");
            this.strs4 = strs4;
          } else if (this.ischinese == "en") {
            this.banner = res.data.data.banner.image;
            this.servicearray = res.data.data.lists;
            // console.log(this.banner)
            let str1 = res.data.data.lists.operate_en;
            let strs1 = str1.split("\n");
            this.strs1 = strs1;

            let str2 = res.data.data.lists.management_en;
            let strs2 = str2.split("\n");
            this.strs2 = strs2;

            let str3 = res.data.data.lists.source_en;
            let strs3 = str3.split("\n");
            this.strs3 = strs3;

            let str4 = res.data.data.lists.logistics_en;
            let strs4 = str4.split("\n");
            this.strs4 = strs4;
          }
        }
      });
    },
    //点击跳转about
    toAbout() {
      window.location.href = "http://test.dashu.xiaoxxx.com/#/Aabout";
    },
    //点击跳转news
    toNewsCenter() {
      window.location.href = "http://test.dashu.xiaoxxx.com/#/Anew";
    },
    routerdetails0() {
      let newarray = this.newarray;
      window.location.href = "http://test.dashu.xiaoxxx.com/#/Anews?detailsid="+newarray[0].id;
    },

    routerdetails1() {
      let newarray = this.newarray;
      window.location.href = "http://test.dashu.xiaoxxx.com/#/Anews?detailsid="+newarray[1].id;
    },
    routerdetails2() {
      let newarray = this.newarray;
      window.location.href = "http://test.dashu.xiaoxxx.com/#/Anews?detailsid="+newarray[2].id;
    },
    //获取关于
    getAbout() {
      this.$http.post("/api/dashu/about/aboutList", {}).then(res => {
        // console.log(res.data.data)
        let code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.about = res.data.data.about;
            //  console.log(this.about)
            let str4 = res.data.data.about.overview;
            let strs4 = str4.split("\n");
            this.strs = strs4;
          } else if (this.ischinese == "en") {
            this.about = res.data.data.about;
            //  console.log(this.about)
            let str4 = res.data.data.about.overview_en;
            let strs4 = str4.split("\n");
            this.strs = strs4;
          }
        }
      });
    },
    //获取加入我们
    getJoin() {
      this.$http.post("/api/dashu/recruit/recruitList", {}).then(res => {
        let code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.joinarray = res.data.data.recruit;
            this.image_one = res.data.data.joins.image_one;
            this.image_two = res.data.data.joins.image_two;
            let str4 = res.data.data.joins.content;
            let strs4 = str4.split("\n");
            this.strs = strs4;
            //  console.log(this.joinarray.length)
            if (this.joinarray.length >= 3) {
              //  console.log("1")
              this.joincenter = 3;
            }
          } else if (this.ischinese == "en") {
            let joinarray = res.data.data.recruit;
            for(let i = 0; i < joinarray.length; i++) {
              //  joinarray[i].menu_en = JSON.parse(joinarray[i].menu_en||'');
              joinarray[i].menu_en = joinarray[i].menu_en.split(";")
            }
            console.log(joinarray);
            this.joinarray = joinarray;
            let str4 = res.data.data.joins.content_en;
            let strs4 = str4.split("\n");
            this.joinstrs = strs4;
            if (this.joinarray.length >= 3) {
              this.joincenter = 2;
            }
          }
        }
      });
    }
  },
  created() {
    this.ischinese = "en";
    this.setEnText();
    this.getBanner();
    this.getAbout();
    this.getJoin();
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
  }
};
</script>
<style>
/* <!-- <style lang="stylus"> --> */
body {
  position: relative;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

.container {
  /* background-color:rgb(244,247,250); */
  background-color: white;
  min-width: max-content;
  min-width: -moz-max-content;
}

.el-carousel--horizontal {
  overflow-x: hidden;
  height: 966px;
}

.top {
  height: 965px;
  overflow: hidden !important;
  position: relative;
  top: -56px;
  /* background-size: cover; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 965px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.banner {
  overflow: hidden !important;
  position: relative;
  /* background-size: cover; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 965px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
}

.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 54px;
  font-weight: bold;
  color: white;
  margin-top: 250px;
}

.bannerp2 {
  margin: 0 auto;
  font-size: 22px;
  line-height: 35px;
  width: 670px;
  overflow: hidden;
  display: -webkit-box;
  /* -webkit-line-clamp: 2; */
  -webkit-box-orient: vertical;
  color: white;
}

.bannerimg {
  position: absolute;
  bottom: 40px;
  left: 49.5%;
  cursor: pointer;
}

.bannerimg:hover {
  bottom: 30px;
  padding-top: 10px;
}

.about {
  overflow: hidden !important;
  position: relative;
  width: 1200px;
  height: 654px;
  /* // margin: 100px auto 50px; */
  margin: 0 auto;
  text-align: center;
}

.service {
  background: #fff;
  width: 100%;
  height: auto;
}

.service .text-title {
  color: #a4a4a4;
}

.service .text-linear {
  /* // background-image: -webkit-gradient(
  // linear,
  // 0 0,
  // 0 bottom,
  // from(#88d7b5),
  // to(transparent)
  // ); */
  color: #59ad89 !important;
}

.service-con {
  display: flex;
  flex-wrap: wrap;
  width: 1400px;
  margin: 0 auto;
  justify-content: center;
}

.service-item {
  width: 510px;
  margin: 0 62px;
  margin-top: 50px;
}

.service-icon {
  width: 212px;
  height: 210px;
}

.servic-title {
  padding: 25px 0;
  color: #333333;
  font-size: 30px;
}

.service-detail {
  font-size: 18px;
  color: #333333;
  line-height: 36px;
  font-weight: lighter;
  text-align: left;
}

.about .text-linear {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 48px;
  font-weight: bold;
  /* // background-image: -webkit-gradient(
  // linear,
  // 0 0,
  // 0 bottom,
  // from(#e9fcf3),
  // to(transparent)
  // );
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent; */
}

.about .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: -60px;
}

.about-div {
  margin: 0px 0 150px 0;
  height: 425px;
  display: flex;
}

.about-div1 {
  background-image: url('../assets/dashu/index_about.png');
  background-size: 100%;
  /* // margin-left: 30px; */
  width: 800px;
  height: 696px;
  background-repeat: no-repeat;
}

.about-div1:hover {
  box-shadow: 0px 0px 20px #888888;
}

.about-div2 {
  width: 600px;
  margin-left: 30px;
}

.aboutExplain {
  margin-top: 60px;
  text-align: left;
  color: #fff;
  font-size: 16px;
  line-height: 28px;
}

.more {
  background: #76c3a2;
  color: white;
  font-size: 16px;
  line-height: 30px;
  width: 126px;
  height: 30px;
  border-radius: 5px;
  position: absolute;
  bottom: 100px;
  cursor: pointer;
}

.about-long {
  width: 100%;
  min-width: 1200px;
  background: #70b597;
  height: 525px !important;
  overflow: hidden;
}

.about-title {
  font-size: 36px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  margin-top: 160px;
}

.news {
  /* overflow: hidden !important; */
  position: relative;
  width: 1200px;
  /* height: 654px; */
  text-align: center;
  margin: 100px auto 100px;
}

.news p {
  text-align: center;
  margin: 0 0 20px 0;
  font-size: 30px;
  font-weight: bold;
}

.news img {
  position: absolute;
  top: 35px;
  left: 20%;
}

.news-span span {
  color: #333333;
  position: absolute;
  right: 0px;
}

.three {
  width: 1200px;
  margin: 30px auto 0;
  display: -ms-flexbox;
  display: flex;
}

.three1, .three2, .three3 {
  width: 30%;
  height: 403px;
  position: relative;
  box-shadow: 10px 0px 20px #888888;
}

.three1 {
  /* background-image: url('../../assets/dashu/new1.png'); */
  background-size: cover;
}

.three2 {
  margin: 0 5%;
  /* background-image: url('../../assets/dashu/new2.png'); */
  background-size: cover;
}

.three3 {
  /* background-image: url('../../assets/dashu/new2.png'); */
  background-size: cover;
}

.newtitle {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  padding: 5%;
  width: 100%;
  height: 100%;
  text-align: left;
  background: #888888;
  border-right: 1px solid #888888;
  opacity: 0.8;
}

.newtitle-span1 {
  color: white;
  text-align: left;
  font-size: 22px;
  line-height: 30px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}

.newtitle-span2 {
  color: white;
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  margin: 20px 0 0px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}

.newtitle-span3 {
  color: white;
  text-align: right;
  font-size: 16px;
  line-height: 17px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
  cursor: pointer;
  position: absolute;
  right: 23px;
  bottom: 26px;
}

.newtitle2 {
  position: absolute;
  bottom: 0;
  padding: 5%;
  width: 90%;
  text-align: left;
  background: #ffffff;
  border-right: 1px solid #ffffff;
  opacity: 1;
}

.newtitle2 span {
  text-align: left;
  font-size: 22px;
  line-height: 28px;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* autoprefixer:off */
  -webkit-box-orient: vertical;
  /* autoprefixer:on */
}

.news .text-linear {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
}

.news .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: -60px;
}

.innovation {
  position: relative;
  width: 1200px;
  text-align: center;
  margin: 100px auto 20px;
}

.innovation .text-linear {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
  margin: 0;
}

.innovation .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: 10px;
}

.inn1 {
  /* height: 1260px; */
  height: 1220px;
  width: 1180px;
  background: white;
  margin: 40px auto 0;
}

.inn1-1 {
  height: 655px;
  width: 1180px;
  background: white;
  position: relative;
  margin-bottom: 60px;
  text-align: left;
}

.innimgl {
  position: absolute;
  top: 0;
  left: 0;
}

.innimgr {
  position: absolute;
  top: 0;
  right: 0;
}

.inn1-2p {
  font-size: 48px;
  font-weight: bold;
  width: 1180px;
  margin: 40px auto 10px;
  padding-top: 70px;
  text-align: center;
  color: #fff;
}

.inn2 .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #fff;
  opacity: 0.3;
  font-weight: bold;
  margin-top: 10px;
}

.inn1-2pp {
  /* // font-size: 30px;
  // font-weight: bold;
  // width: 1180px;
  // margin: 40px auto 0px;
  // padding-bottom: 76px; */
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
  margin: 0;
}

.inn1-2ppp {
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  width: 1180px;
  margin: 70px auto 20px;
  text-align: center;
}

.innp1 {
  text-align: left;
  color: #fff;
  font-size: 22px;
  margin: 0;
  margin-bottom: 25px;
}

.innp1_2 {
  display: block;
  height: 50px;
  color: #fff;
  font-size: 22px;
  margin: 0;
  margin-bottom: 25px;
}

.innp3 {
  color: black;
  font-size: 22px;
  margin-bottom: 30px;
}

.innp2 {
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  margin: 0;
}

.inn1-2 {
  height: 355px;
  width: 1180px;
  background: white;
}

.inn1-2 .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: 10px;
}

.inn1-2-1 {
  display: flex;
  width: 1180px;
  margin-top: 30px;
}

.inn1-2-1-1 {
  width: 30%;
  text-align: center;
}

.inncenter {
  margin: 0 5%;
}

.inn2 {
  margin: 20px auto 0;
  width: 100%;
  background: #70b597;
  text-align: center;
}

.inn2-2-1 {
  display: flex;
  width: 1180px;
  margin: 0 auto;
  color: #fff;
}

.inn2-2-1-1 {
  width: 25%;
  margin: 70px 0;
  text-align: center;
}

.inn2-2-1-1 ul {
  text-align: left;
  font-size: 14px;
  line-height: 1.6;
}

.inn2-img {
  /* // margin-left: -40px; */
}

.inn3 {
  background: white;
  margin: 20px auto 160px;
  text-align: center;
}

.inn3-2-1-1 {
  width: 50%;
  margin: 0;
  text-align: left;
}

.con {
  box-sizing: border-box;
  background: #70b597;
  padding: 20px 12px;
  min-height: 210px;
  min-width: 400px;
}

.inntitle1 {
  position: absolute;
  top: 95px;
  left: 50px;
  color: white;
  font-weight: bold;
  font-size: 30px;
}

.inndesc1 {
  position: absolute;
  top: 185px;
  left: 50px;
  color: white;
  font-size: 14px;
  width: 480px;
  letter-spacing: 1px;
  line-height: 1.6;
}

.inntitle2 {
  position: absolute;
  top: 95px;
  left: 670px;
  color: white;
  font-weight: bold;
  font-size: 30px;
}

.inndesc2 {
  position: absolute;
  top: 185px;
  left: 670px;
  color: white;
  font-size: 14px;
  width: 480px;
  letter-spacing: 1px;
  line-height: 1.6;
}

.long-innovation-test {
  text-align: left;
  width: 1180px;
  margin: 0 auto;
  font-size: 30px;
}

.img-con {
  height: 120px;
}

.inn3 ul {
  width: 500px;
  color: #999999;
  font-size: 14px;
  padding: 0 0 0 20px;
  text-align: left;
}

.inn3 li {
  line-height: 1.6;
}

.inn3 .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: -60px;
}

.cooperation {
  /* display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; */
  margin: 0 auto;
  margin-top: 40px;
  width: 100%;
  height: 670px;
}

.slide-title {
  width: 100%;
  padding: 20px;
  font-size: 36px;
  color: #333333;
  text-align: left;
}

.bread-item {
  /* position: relative;
  width: 132px;
  height: 95px;
  line-height: 95px;
  border-radius: 10px; */
  /* flex-grow: 1; */
  width: 30%;
  /* height: 95px; */
  box-sizing: border-box;
  margin: 10px 0 0 10px;
  border-radius: 10px;
  overflow: hidden;
}

.img-size {
  width: 100%;
  height: 100%;
  transform: scale(1.1, 1.1);
}

.bread-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url('../assets/dashu/mz_bg.png');
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}

.muying-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url('../assets/dashu/my_bg.png');
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}

.food-con {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  width: 95%;
  height: 582px;
  margin: 0 auto;
  border-radius: 10px;
  background: #f9f9f9;
  background-image: url('../assets/dashu/food_bg.png');
  background-size: 100% 100%;
  background-position: right bottom;
  overflow: hidden;
}

.swiper-black {
  background: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* opacity: 1; */
}

.swiper-black img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 26px;
  margin-top: -13px;
  margin-left: -10px;
  transform: rotate(180deg);
}

.swiper-white {
  /* position: relative; */
  background: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* opacity: 1; */
}

.swiper-white img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 16px;
  height: 26px;
  margin-top: -13px;
  margin-left: -6px;
}

.cooperation {
  /* display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; */
  margin: 0 auto;
  margin-top: 40px;
  width: 100%;
  height: 670px;
}

.cooperation .swiper-con {
  width: 100%;
  height: 100%;
}

.bread-about {
  overflow: hidden !important;
  position: relative;
  width: 1200px;
  height: 654px;
  margin: 100px auto 50px;
  text-align: center;
}

.about2 {
  margin: 100px auto 0px;
  height: 850px;
}

.my-button-disabled {
  opacity: 0.8 !important;
}

.my-button-hidden {
  opacity: 0.8 !important;
}

.about2 .text-linear {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  margin-top: -60px;
  margin: 0;
}

.about2 .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: 10px;
}

.about-us {
  overflow: hidden !important;
  position: relative;
  width: 1200px;
  /* // height: 554px; */
  margin: 0 auto;
  text-align: center;
}

.about1 {
  width: 1180px;
  background: white;
  margin: 40px auto 0;
}

.about1-2 {
  width: 1180px;
  background: white;
}

.one {
  text-align: center !important;
}

.aboutp1 {
  font-size: 30px;
  font-weight: bold;
  text-align: left;
}

.servicesp1, .servicesp2 {
  color: grey;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
}

.servicesp1 {
  margin: 0px 0 30px 0;
  text-align: left;
}

.servicesp22 {
  margin: 0px 0 150px 0;
  color: grey;
}

.about-text-long {
  color: #333333;
  font-size: 30px;
  font-weight: bold;
}

.s-margin {
  margin: 15px 0;
}

.join-con {
  width: 100%;
  min-height: 580px;
  background: #70b597;
}

.join-title {
  text-align: center;
  color: #fff;
  font-size: 48px;
  font-weight: bold;
  padding-top: 60px;
}

.join-title2 {
  text-align: center;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  padding-top: 20px;
}

.join-content-con {
  width: 1200px;
  margin: 0 auto;
}

.why-join {
  text-align: left;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  padding: 20px 0 30px 0;
}

.why {
  font-size: 24px;
  line-height: 1.6;
  color: #fff;
}

.recruit-flex {
  width: 1350px;
  min-height: 630px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: center;
}

.recruit-item {
  box-sizing: border-box;
  /* // width: 20%; */
  padding: 60px 10px 20px 10px;
}
.recruit-con {
  text-align: center;
  background: #f3f3f3
}
.recruit-title {
  text-align: center;
  color: #59ad89;
  font-size: 48px;
  font-weight: bold;
  padding-top: 60px;
}
.recruit-con .under-line {
  display: inline-block;
  width: 136px;
  height: 4px;
  text-align: center;
  background: #59ad89;
  opacity: 0.3;
  font-weight: bold;
  margin-top: 10px;
}
.recruit-icon {
  /* // width: 180px;
  // height: 180px; */
  margin: 0 auto;
}
.recruit-icon image {
  width: 241px;
  height: 201px;
}
.recruit-name {
  color: #333;
  font-size: 22px;
}
.recruit-detail {
  margin-top: 30px;
}
.recruit-detail div{
  line-height: 1.8
}
</style>
